import { render, staticRenderFns } from "./ThePriceCompetitor.vue?vue&type=template&id=351c7f7e&scoped=true&"
import script from "./ThePriceCompetitor.vue?vue&type=script&lang=js&"
export * from "./ThePriceCompetitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351c7f7e",
  null
  
)

export default component.exports